import { render, staticRenderFns } from "./WhatsAppMessagesCard.vue?vue&type=template&id=6a761b43&scoped=true"
import script from "./WhatsAppMessagesCard.vue?vue&type=script&lang=js"
export * from "./WhatsAppMessagesCard.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppMessagesCard.vue?vue&type=style&index=0&id=6a761b43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a761b43",
  null
  
)

export default component.exports